module.exports = __webpack_public_path__ + "static/logo_oms_pride.c5bf9461.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_oms_pride.svg
// module id = 359
// module chunks = 95715928098905 114276838955818